module.exports = __webpack_public_path__ + "static/media/5.75c94e19.png";